import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WrenchIcon, TrashIcon, ArchiveIcon } from 'lucide-react';
import { FormSection, DisplayField, TextAreaField, TextField } from '../components/FormComponents';
import { StatusBadge } from '../components/StatusBadge';
import { mockQCEntries } from '../data/mockData';
export function DisposalRepairAction() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const data = mockQCEntries.find(q => q.id === id);
  const [actionType, setActionType] = useState<'Disposal' | 'Repair' | 'Return to Stock'>('Repair');
  const [actionQty, setActionQty] = useState(data?.rejectedQty || 0);
  const [remarks, setRemarks] = useState('');
  if (!data) return <div data-id="element-681">Record not found</div>;
  const handleExecute = () => {
    if (actionQty > data.rejectedQty) {
      alert('Action quantity cannot exceed rejected quantity.');
      return;
    }
    if ((actionType === 'Disposal' || actionType === 'Return to Stock') && !remarks) {
      alert('Remarks are mandatory for Disposal or Return to Stock.');
      return;
    }
    alert(`Successfully executed ${actionType} for ${actionQty} items.`);
    navigate(-1);
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-682">
      <div className="flex items-center justify-between" data-id="element-683">
        <div data-id="element-684">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-685">
            Disposal & Repair Action
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-686">
            Determine action for rejected items.
          </p>
        </div>
        <StatusBadge status={data.qcStatus} className="text-sm px-3 py-1" data-id="element-687" />
      </div>

      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8 space-y-8" data-id="element-688">
        <FormSection title="QC Details" data-id="element-689">
          <DisplayField label="QC Ref No" value={data.qcReferenceNo} data-id="element-690" />
          <DisplayField label="Product/Item" value={data.product} data-id="element-691" />
          <DisplayField label="Warehouse" value={data.warehouse} data-id="element-692" />
          <DisplayField label="Total QC Quantity" value={data.quantity} data-id="element-693" />
          <DisplayField label="QC Inspector" value={data.qcInspector} data-id="element-694" />
          <DisplayField label="Inspector Remarks" value={data.qcRemarks} data-id="element-695" />
        </FormSection>

        <FormSection title="QC Result Summary" data-id="element-696">
          <DisplayField label="Accepted Qty" value={<span className="text-green-600 font-bold" data-id="element-698">
                {data.acceptedQty}
              </span>} data-id="element-697" />
          <DisplayField label="Rejected Qty" value={<span className="text-red-600 font-bold" data-id="element-700">{data.rejectedQty}</span>} data-id="element-699" />
        </FormSection>

        <div className="border-t border-gray-200 pt-8" data-id="element-701">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-702">
            Action Details
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-703">
            <div className="md:col-span-2" data-id="element-704">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-705">
                Action Type
              </label>
              <div className="flex space-x-4" data-id="element-706">
                <button onClick={() => setActionType('Repair')} className={`flex-1 flex items-center justify-center px-4 py-3 border rounded-md text-sm font-medium ${actionType === 'Repair' ? 'bg-indigo-50 border-indigo-500 text-indigo-700' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`} data-id="element-707">
                  <WrenchIcon className="h-4 w-4 mr-2" data-id="element-708" /> Repair
                </button>
                <button onClick={() => setActionType('Disposal')} className={`flex-1 flex items-center justify-center px-4 py-3 border rounded-md text-sm font-medium ${actionType === 'Disposal' ? 'bg-red-50 border-red-500 text-red-700' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`} data-id="element-709">
                  <TrashIcon className="h-4 w-4 mr-2" data-id="element-710" /> Disposal
                </button>
                <button onClick={() => setActionType('Return to Stock')} className={`flex-1 flex items-center justify-center px-4 py-3 border rounded-md text-sm font-medium ${actionType === 'Return to Stock' ? 'bg-green-50 border-green-500 text-green-700' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`} data-id="element-711">
                  <ArchiveIcon className="h-4 w-4 mr-2" data-id="element-712" /> Return to Stock
                </button>
              </div>
            </div>

            <TextField label="Action Quantity" type="number" min="1" max={data.rejectedQty} value={actionQty} onChange={e => setActionQty(Number(e.target.value))} required data-id="element-713" />
          </div>

          <TextAreaField label="Action Remarks" name="remarks" value={remarks} onChange={e => setRemarks(e.target.value)} placeholder="Enter remarks (mandatory for Disposal and Return)..." rows={3} required={actionType === 'Disposal' || actionType === 'Return to Stock'} data-id="element-714" />

          <div className="mt-6 flex justify-end" data-id="element-715">
            <button onClick={handleExecute} className="inline-flex justify-center items-center px-6 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-716">
              Execute Action
            </button>
          </div>
        </div>
      </div>
    </div>;
}